module.exports = __webpack_public_path__ + "img/newTitle.92d298bf.png";